
const categorySchema = {
    type: "array",
    items: { type: "string" },
}

module.exports = { categorySchema };